import React,{useState,useEffect,useContext} from 'react'
import systemMasterServices from '../app/master/systemMasterServices';
import projectServices from '../app/admin/erp/project/projectServices';
import userServices from '../app/admin/user/userServices';
import projectLocationServices from '../app/admin/erp/project/projectLocationServices';
import employeeServices from '../app/admin/erp/employee/employeeServices';

const AppESSDataContext = React.createContext();

export const useEssAppData = () => {
    return useContext(AppESSDataContext);
}

export const AppESSDataProvider = (props) =>{
    
    const [loading,setLoadingStatus] = useState(false)
    const [masters,setMasters] = useState(null);
    
    const [employeeList,setEmployeeList] = useState(null);
    const [employeeDD,  setEmployeeDD] = useState(null);
    
    const [projectList,setProjectList] = useState(null);
    const [projectDD, setProjectDD] = useState(null)
    
    const [projectLocationList,setProjectLocationList] = useState(null);
    const [projectLocationDD,setProjectLocationDD] = useState(null);

    const [userDD, setUserDD] = useState(null);
    
    const getMasterList = () => {
        systemMasterServices.get([
                "billing-type",
                "business-type",
                "department",
                "document-category",
                "document-status",
                "document-type",
                "employee-designation",
                "employee-type",
                "expense-type",
                "gender",
                "grievance-status",
                "grievance-type",
                "indian-state",
                "inventory-type",
                "leave-type",
                "po-status",
                "product-brand",
                "product-category",
                "product-uom",
                "task-status",
                'vendor-category',
                "tender-type",
                "transaction-method"
            ]).then(res=>{
            setMasters(res);
        }).catch(error=>{
        })
    }
    
    const getMasterLabel = (type, id) => {
        try{
            let label = masters[type].find(m => m.value === id)
            return label.label;
        } catch(e){
            //console.log(type,id);
            return "";
        }
    }

    const getEmployeeList = () =>{
        setLoadingStatus(true);
        employeeServices.getList().then(res=>{
            setEmployeeList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
    const getEmployeeDD = () =>{
        setLoadingStatus(true);
        employeeServices.getDD().then(res=>{
            setEmployeeDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getProjectList = () =>{
        setLoadingStatus(true);
        projectServices.getList().then(res=>{
            setProjectList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getProjectDD = () =>{
        setLoadingStatus(true);
        projectServices.getDD().then(res=>{
            setProjectDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getProjectLocationList = () =>{
        setLoadingStatus(true);
        projectLocationServices.getList().then(res=>{
            setProjectLocationList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getProjectLocationDD = () =>{
        setLoadingStatus(true);
        projectLocationServices.getDD().then(res=>{
            setProjectLocationDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
        
    const getUserDD = () =>{
        setLoadingStatus(true);
        userServices.getDD().then(res=>{
            setUserDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
    
    const getAppDataById = (dataArray,id) =>{
        try{
            let data =  dataArray?.find(d => d.id === id)
            return data;
        } catch(e){
            //console.log(type,id);
            return "";
        } 
    }

    const getDDDataById = (dataArray,value) =>{
        try{
            let data =  dataArray?.find(d => d.value === value)
            return data;
        } catch(e){
            //console.log(type,id);
            return "";
        } 
    }

    const value= {
        masters,getMasterLabel,
        employeeList,getEmployeeList, employeeDD,getEmployeeDD,
        projectList,getProjectList, projectDD,getProjectDD,
        projectLocationList,getProjectLocationList,projectLocationDD,getProjectLocationDD,
        userDD,getUserDD,
        getAppDataById, getDDDataById,
        loading
    }

    useEffect(()=>{
        getMasterList();
        getEmployeeDD();
        getProjectDD()
        getProjectLocationDD();
        getUserDD();
    },[])
    
    return (
        masters && projectDD && projectLocationDD && userDD && employeeDD && 
        <AppESSDataContext.Provider value= {value}>{props.children}</AppESSDataContext.Provider>
    )
}